import React from "react";
import { IMAGES } from "../assets/img/ImageIndex";
import { Link } from "react-router-dom";

const GuideArea = () => {
  return (    
    <div className="container mw-1380">
        <div className="guide-wrap position-relative z-1">
            <div className="row align-items-center">
                <div className="col-lg-6">
                    <div className="guide-content">
                        <h2>A team of business finance experts to guide you every step of the way.</h2>
                        <p>We know that securing the right business loan can be complex, so we simplify the process with tailored financing solutions designed to save you time and money while fueling your growth.</p>
                    </div>
                </div>

                <div className="col-lg-6">
                    <div className="guide-info">
                        <ul className="ps-0 list-unstyled">
                            <li>
                                <i className="ri-phone-fill"></i>
                                <Link to="tel:(800) 371-5360">(800) 371-5360</Link> </li>
                            <li>
                                <i className="ri-mail-line"></i>
                                <Link to="mailto:info@envocapital.com"><span className="__cf_email__">info@envocapital.com</span></Link>                                                                                </li>
                        </ul>
                        <Link to="https://app.envocapital.com" className="btn border-0 bg-white" target="_blank">Apply Now</Link>
                    </div>
                </div>
            </div>
            <img decoding="async" src={IMAGES.shape2} className="shape shape-2 d-none d-xxl-block" alt="shape"/>
        </div>
    </div>
  );
};

export default GuideArea;
